import moment from 'moment';
import React, { Fragment, useEffect, memo, useState } from 'react';
import {
  FiDownload,
  FiChevronDown,
  FiChevronUp,
  FiClock,
  FiChevronLeft,
} from 'react-icons/fi';
import { CgSoftwareDownload } from 'react-icons/cg';
import { downloadRadiologyReport, viewRadiologyXrayReport } from '../../../utilFunctions/reports/reports';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../../store/languageSlice';
import { formatDate } from '../../../translations/common';
import useBreakpoint from '../../../utilFunctions/useBreakpoint';
import { timeFormat } from '../../../utilFunctions/DateFormatter';

const ReportItem = ({ t, isRtl, item }) => {
  const { isMobile } = useBreakpoint();

  const formatedItem = {
    reportName: item?.order_description,
    value: item?.order_status || '',
    referenceRange: '',
    Interpretation: item?.authorized_user || '',
    dateTime: `${item?.result_date || ''} ${timeFormat(item?.result_time)}`,
  };
  return (
    <>
      {!isMobile && (
        <div className="cursor-pointer">
          <div className="type">
            <img
              src={`${process.env.PUBLIC_URL}/images/icons/ic_radiology_report_hov.svg`}
              alt="report icon"
            />
            {formatedItem.reportName}
          </div>
          <div className="val">
            {/* {t.Value}:
            <span className="text-secondary font-medium">{formatedItem.value}</span> */}
            {formatedItem.value}
          </div>
          <div className="rng">
            {/* {t.ReferenceRange}:
            <span className="text-secondary font-medium">
              {formatedItem.referenceRange}
            </span> */}
            {formatedItem.referenceRange}
          </div>
          <div className="intp">
            {/* {t.Interpretation}:
            <span className="text-secondary font-medium">
              {formatedItem.Interpretation}
            </span> */}
            {formatedItem.Interpretation}
          </div>
          <div className="clctDate">
            {/* {t.CollectionDateTime}:
            <span className="text-secondary font-medium">
              {formatedItem.dateTime}
            </span> */}
            {formatedItem.dateTime}
          </div>
        </div>
      )}
      {isMobile && (
        <div className="sngl">
          <p>
            <span>{t.Value}:</span>
            {formatedItem.value}
          </p>
          <p>
            <span>{t.ReferenceRange}:</span>
            {formatedItem.referenceRange}
          </p>
          <p>
            <span>{t.Interpretation}:</span>
            {formatedItem.Interpretation}
          </p>
          <p>
            <span>{t.CollectionDateTime}:</span>
            {formatedItem.dateTime}
          </p>
          <p className="name">{formatedItem.reportName}</p>
        </div>
      )}
    </>
  );
};

const RadiologyReport = ({ listData, currentData }) => {
  const { isMobile } = useBreakpoint();
  const allowXrayImage = useSelector((state) => state.hospitalInfo.selectedHospital.allowXRAYImages);
  const hospitalList = useSelector((state) => state.hospitalInfo.list);
  console.log("hospitalList", useSelector((state) => state.hospitalInfo.list))
  const { t, isRtl } = useSelector(selectLanguage);

  const [reportData, setReportData] = useState([]);
  const [showRecords, setShowRecord] = useState([]);

  const handleDownloadReport = async (orderId, obgyn) => {    
    if (!orderId && orderId == '') return;

    await downloadRadiologyReport(orderId, obgyn);
  };

  const handleViewReport = async (orderAccessionNumber) => {
    if (!orderAccessionNumber && orderAccessionNumber == '') return;
    // console.log("orderAccessionNumber", orderAccessionNumber)
    await viewRadiologyXrayReport(orderAccessionNumber);
  }

  const toggleShowRecords = (indexId) => {
    if (showRecords.includes(indexId)) {
      setShowRecord(showRecords.filter((x) => x !== indexId));
    } else {
      setShowRecord([...showRecords, indexId]);
    }
  };

  useEffect(() => {
    if (listData?.length > 0) {
      const sortedByDate = listData
        .slice()
        .sort((a, b) =>
          moment(b.collected_date).diff(moment(a.collected_date))
        );

      setReportData([...reportData, ...sortedByDate]);
    }
  }, [listData]);

  if (!currentData) return null;

  if (listData.length === 0)
    return (
      <div className="w-full h-full mt-14 flex justify-center">
        <div className="font-semibold text-2xl text-blue-900">
          {t.NoDataFound}
        </div>
      </div>
    );

  return (
    <Fragment key={'RaioLab'}>
      {reportData.map((item, index) => {
        const orderItem = {
          date: item?.result_date,
          oderId: item?.order_id,
          docName: item?.ordered_doctor,
          time: item?.result_time,
          orderAccessionNumber: item?.order_accession_number,
          is_obgyn: item?.is_obgyn,
        };

        const fDate = formatDate(orderItem.date, isRtl);
        const time =
          orderItem.time !== ''
            ? moment(orderItem.time, 'HH:mm').format('hh:mm A')
            : '';
        const show = showRecords.includes(index);

        const reportHospital = hospitalList.filter(hospotal => hospotal.hospitalCode === item?.hospital_code);

        // console.log("reportHospital", reportHospital)
        // console.log("!reportHospital.allowXRAYImages", reportHospital?.allowXRAYImages)

        return (
          <>
            {!isMobile && (
              <div key={'radio' + index} className="sngRpt">
                <div className="info">
                  <div className="no">{index + 1}.</div>
                  <div className="date">
                    <span>{fDate.weekName}</span>
                    {`${fDate.monthDate} ${fDate.monthNameShort}`}
                    {/* <span>{`${fDate.year}`}</span> */}
                  </div>
                  <div className="year">{`${fDate.year}`}</div>
                  <div className="id">{orderItem?.oderId || ''}</div>
                  <div className="by">{orderItem?.docName || ''}</div>
                  <div className="time">{time || ''}</div>
                  <div
                    className={`download ${!reportHospital[0]?.allowXRAYImages || !orderItem?.orderAccessionNumber ? 'column' : ''}`}
                  >
                    <button onClick={() => handleDownloadReport(orderItem.oderId, orderItem.is_obgyn)}>
                      {t.Download} <CgSoftwareDownload />
                    </button>
                    {
                      orderItem?.orderAccessionNumber && <button onClick={() => handleViewReport(orderItem?.orderAccessionNumber)}>
                      {t.View} <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.5 5C5.22386 5 5 5.22386 5 5.5V7.5C5 7.77614 5.22386 8 5.5 8H12.5C12.7761 8 13 7.77614 13 7.5V5.5C13 5.22386 12.7761 5 12.5 5H5.5ZM6 7V6H12V7H6ZM3 4C3 2.89543 3.89543 2 5 2H13C14.1046 2 15 2.89543 15 4V16C15 17.1046 14.1046 18 13 18H9.87937C10.1568 17.6836 10.3876 17.3508 10.5659 17.019L10.5761 17H13C13.5523 17 14 16.5523 14 16V4C14 3.44772 13.5523 3 13 3H5C4.44772 3 4 3.44772 4 4V11.1968C3.64559 11.2922 3.31172 11.4189 3 11.5693V4ZM16 6H16.5C16.7761 6 17 6.22386 17 6.5V8C17 8.27614 16.7761 8.5 16.5 8.5H16V6ZM16.5 9.5H16V12H16.5C16.7761 12 17 11.7761 17 11.5V10C17 9.72386 16.7761 9.5 16.5 9.5ZM16 13H16.5C16.7761 13 17 13.2239 17 13.5V15C17 15.2761 16.7761 15.5 16.5 15.5H16V13ZM1 15.5C1 14.318 2.736 12 5.5 12C8.261 12 10 14.3 10 15.5C10 16.682 8.261 19 5.5 19C2.739 19 1 16.7 1 15.5ZM4.11107 17.5787C4.5222 17.8534 5.00555 18 5.5 18C6.16304 18 6.79893 17.7366 7.26777 17.2678C7.73661 16.7989 8 16.163 8 15.5C8 15.0055 7.85338 14.5222 7.57867 14.1111C7.30397 13.7 6.91352 13.3795 6.45671 13.1903C5.99989 13.0011 5.49723 12.9516 5.01227 13.048C4.52732 13.1445 4.08186 13.3826 3.73223 13.7322C3.3826 14.0819 3.1445 14.5273 3.04804 15.0123C2.95157 15.4972 3.00108 15.9999 3.1903 16.4567C3.37952 16.9135 3.69995 17.304 4.11107 17.5787ZM6.7472 16.3334C6.91203 16.0867 7 15.7967 7 15.5C7 15.1022 6.84196 14.7206 6.56066 14.4393C6.27936 14.158 5.89782 14 5.5 14C5.20333 14 4.91332 14.088 4.66665 14.2528C4.41997 14.4176 4.22771 14.6519 4.11418 14.926C4.00065 15.2001 3.97094 15.5017 4.02882 15.7926C4.0867 16.0836 4.22956 16.3509 4.43934 16.5607C4.64912 16.7704 4.91639 16.9133 5.20736 16.9712C5.49834 17.0291 5.79994 16.9993 6.07403 16.8858C6.34811 16.7723 6.58238 16.58 6.7472 16.3334Z" fill="#ffffff"/>
</svg>

                    </button>
                    }
                  </div>
                  <div className="toggle">
                  <button
                    onClick={() => toggleShowRecords(index)}
                    className="collapseBtn"
                  >
                    {show ? <FiChevronUp /> : <FiChevronDown />}
                  </button>
                  </div>
                </div>
                {show && (
                  <div className="otherInfo">
                    <div className="otherInfoHead">
                      <div className="type">
                        <div className="opacity-0">type</div>
                      </div>
                      <div className="val">
                        <div>{t.Value}</div>
                      </div>
                      <div className="rng">
                        <div>{t.ReferenceRange}</div>
                      </div>
                      <div className="intp">
                        <div>{t.Intrepatation}</div>
                      </div>
                      <div className="clctDate">
                        <div>{t.CollectionDateTime}</div>
                      </div>
                    </div>
                    <ReportItem t={t} isRtl={isRtl} item={item} key={index} />
                  </div>
                )}
              </div>
            )}
            {isMobile && (
              <div className="snglRprt">
                <div className="card">
                  <div className="date text-gray-500">
                    <span className="day font-medium text-slate-950">
                      {fDate.monthNameShort}
                    </span>
                    <span className="date font-bold text-24 text-primary">
                      {fDate.monthDate}
                    </span>
                    {fDate.year}
                  </div>
                  <div className="info">
                    <h3 className="text-slate-950">
                      Order ID: {orderItem?.oderId || ''}
                    </h3>
                    <h4 className="text-green">{orderItem?.docName || ''}</h4>
                    <p className=" text-gray-500">
                      <FiClock /> at {time || ''}
                    </p>
                  </div>
                  <div className="btns">
                    <button
                      className="dwnld"
                      onClick={() => handleDownloadReport(orderItem.oderId, orderItem.is_obgyn)}
                    >
                      {t.Download} <CgSoftwareDownload />
                    </button>
                    {
                    (reportHospital[0]?.allowXRAYImages && orderItem?.orderAccessionNumber) &&
                      <button className="view" onClick={() => handleViewReport(orderItem?.orderAccessionNumber)}>
                        {t.View} <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.5 5C5.22386 5 5 5.22386 5 5.5V7.5C5 7.77614 5.22386 8 5.5 8H12.5C12.7761 8 13 7.77614 13 7.5V5.5C13 5.22386 12.7761 5 12.5 5H5.5ZM6 7V6H12V7H6ZM3 4C3 2.89543 3.89543 2 5 2H13C14.1046 2 15 2.89543 15 4V16C15 17.1046 14.1046 18 13 18H9.87937C10.1568 17.6836 10.3876 17.3508 10.5659 17.019L10.5761 17H13C13.5523 17 14 16.5523 14 16V4C14 3.44772 13.5523 3 13 3H5C4.44772 3 4 3.44772 4 4V11.1968C3.64559 11.2922 3.31172 11.4189 3 11.5693V4ZM16 6H16.5C16.7761 6 17 6.22386 17 6.5V8C17 8.27614 16.7761 8.5 16.5 8.5H16V6ZM16.5 9.5H16V12H16.5C16.7761 12 17 11.7761 17 11.5V10C17 9.72386 16.7761 9.5 16.5 9.5ZM16 13H16.5C16.7761 13 17 13.2239 17 13.5V15C17 15.2761 16.7761 15.5 16.5 15.5H16V13ZM1 15.5C1 14.318 2.736 12 5.5 12C8.261 12 10 14.3 10 15.5C10 16.682 8.261 19 5.5 19C2.739 19 1 16.7 1 15.5ZM4.11107 17.5787C4.5222 17.8534 5.00555 18 5.5 18C6.16304 18 6.79893 17.7366 7.26777 17.2678C7.73661 16.7989 8 16.163 8 15.5C8 15.0055 7.85338 14.5222 7.57867 14.1111C7.30397 13.7 6.91352 13.3795 6.45671 13.1903C5.99989 13.0011 5.49723 12.9516 5.01227 13.048C4.52732 13.1445 4.08186 13.3826 3.73223 13.7322C3.3826 14.0819 3.1445 14.5273 3.04804 15.0123C2.95157 15.4972 3.00108 15.9999 3.1903 16.4567C3.37952 16.9135 3.69995 17.304 4.11107 17.5787ZM6.7472 16.3334C6.91203 16.0867 7 15.7967 7 15.5C7 15.1022 6.84196 14.7206 6.56066 14.4393C6.27936 14.158 5.89782 14 5.5 14C5.20333 14 4.91332 14.088 4.66665 14.2528C4.41997 14.4176 4.22771 14.6519 4.11418 14.926C4.00065 15.2001 3.97094 15.5017 4.02882 15.7926C4.0867 16.0836 4.22956 16.3509 4.43934 16.5607C4.64912 16.7704 4.91639 16.9133 5.20736 16.9712C5.49834 17.0291 5.79994 16.9993 6.07403 16.8858C6.34811 16.7723 6.58238 16.58 6.7472 16.3334Z" fill="#ffffff"/>
  </svg>
                      </button>
                    }                    
                    <button
                      className="collapseBtn"
                      onClick={() => toggleShowRecords(index)}
                    >
                      {show ? <FiChevronDown /> : <FiChevronLeft />}
                    </button>
                  </div>
                </div>
                {show && (
                  <div className="moreInfo">
                    <ReportItem t={t} isRtl={isRtl} item={item} key={index} />
                  </div>
                )}
              </div>
            )}
          </>
        );
      })}
    </Fragment>
  );
};

export default memo(RadiologyReport);
